import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/music`;
const hdr = () => { const h = {}; const t = localStorage.getItem("admin_token"); if (t) h.Authorization = `Bearer ${t}`; const pin = localStorage.getItem("checkin_pin"); if (pin) h["X-HK-PIN"] = pin; return { headers: h }; };

export const musicApi = {
  state: () => axios.get(`${API}/state`, hdr()).then((r) => r.data),
  patchZone: (id, body) => axios.patch(`${API}/zones/${id}`, body, hdr()).then((r) => r.data),
  skip: (id) => axios.post(`${API}/zones/${id}/skip`, {}, hdr()).then((r) => r.data),
  refreshReceiver: (id) => axios.post(`${API}/zones/${id}/refresh`, {}, hdr()).then((r) => r.data),
  all: (action) => axios.post(`${API}/all/${action}`, {}, hdr()).then((r) => r.data),
  addTheme: (body) => axios.post(`${API}/themes`, body, hdr()).then((r) => r.data),
  delTheme: (id) => axios.delete(`${API}/themes/${id}`, hdr()).then((r) => r.data),
  addSlot: (body) => axios.post(`${API}/schedule`, body, hdr()).then((r) => r.data),
  delSlot: (id) => axios.delete(`${API}/schedule/${id}`, hdr()).then((r) => r.data),
  setStation: (stream_base) => axios.patch(`${API}/station`, { stream_base }, hdr()).then((r) => r.data),
  patchTheme: (id, body) => axios.patch(`${API}/library/themes/${id}`, body, hdr()).then((r) => r.data),
  uploadChunk: (themeId, form) => axios.post(`${API}/library/upload/${themeId}/chunk`, form, hdr()).then((r) => r.data),
  pendingUploads: () => axios.get(`${API}/library/uploads/pending`, hdr()).then((r) => r.data),
  retryUploads: () => axios.post(`${API}/library/uploads/retry`, {}, hdr()).then((r) => r.data),
  deleteTrack: (folder, file) => axios.post(`${API}/library/tracks/delete`, { folder, file }, hdr()).then((r) => r.data),
  moveTrack: (folder, file, to_folder) => axios.post(`${API}/library/tracks/move`, { folder, file, to_folder }, hdr()).then((r) => r.data),
  playTrack: (folder, file, zone) => axios.post(`${API}/library/tracks/play`, { folder, file, zone }, hdr()).then((r) => r.data),
  setBirthday: (folder, file) => axios.patch(`${API}/library/special/birthday`, { folder, file }, hdr()).then((r) => r.data),
  playBirthday: (zone) => axios.post(`${API}/library/special/birthday/${zone}`, {}, hdr()).then((r) => r.data),
  projector: () => axios.get(`${API}/projector`, hdr()).then((r) => r.data),
  setProjector: (body) => axios.put(`${API}/projector`, body, hdr()).then((r) => r.data),
  projectorAction: (action, minutes) => axios.post(`${API}/projector/action`, minutes ? { action, minutes } : { action }, hdr()).then((r) => r.data),
  presetProjectorSlots: () => axios.post(`${API}/projector/slots/preset`, {}, hdr()).then((r) => r.data),
  addProjectorSlot: (body) => axios.post(`${API}/projector/slots`, body, hdr()).then((r) => r.data),
  delProjectorSlot: (id) => axios.delete(`${API}/projector/slots/${id}`, hdr()).then((r) => r.data),
  uploadProjectorChunk: (form) => axios.post(`${API}/projector/video/chunk`, form, hdr()).then((r) => r.data),
  deleteProjectorVideo: () => axios.delete(`${API}/projector/video`, hdr()).then((r) => r.data),
  useLocalProjectorVideo: (body) => axios.post(`${API}/projector/video/use-local`, body, hdr()).then((r) => r.data),
  irDiscover: () => axios.post(`${API}/projector/ir/discover`, {}, hdr()).then((r) => r.data),
  irSetDevice: (body) => axios.put(`${API}/projector/ir/device`, body, hdr()).then((r) => r.data),
  irLearn: (key) => axios.post(`${API}/projector/ir/learn`, { key }, hdr()).then((r) => r.data),
  irSend: (key) => axios.post(`${API}/projector/ir/send`, { key }, hdr()).then((r) => r.data),
  irDelCode: (key) => axios.delete(`${API}/projector/ir/codes/${key}`, hdr()).then((r) => r.data),
};

export const CHUNK_SIZE = 1.5 * 1024 * 1024;

async function uploadChunked(file, send, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  let res = null;
  for (let i = 0; i < total; i++) {
    const form = new FormData();
    form.append("upload_id", uploadId);
    form.append("index", String(i));
    form.append("total", String(total));
    form.append("filename", file.name);
    form.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE), "chunk.bin");
    res = await send(form);
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return res;
}

export const uploadTrack = (themeId, file, onProgress) => uploadChunked(file, (form) => musicApi.uploadChunk(themeId, form), onProgress);
export const uploadProjectorVideo = (file, onProgress) => uploadChunked(file, musicApi.uploadProjectorChunk, onProgress);

export const DAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
